import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import {
  FaUserPlus,
  FaEnvelope,
  FaLock,
  FaArrowLeft,
  FaCheckCircle,
} from "react-icons/fa";

import { auth, db } from "../firebase";
import logo from "../assets/TW logo img.jpeg";

function CustomerRegister() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);

  const normalizeEmail = (value) => {
    return value.trim().toLowerCase();
  };

  const createPassword = async () => {
    try {
      if (!email || !password) {
        alert("Please enter email and password.");
        return;
      }

      if (password.length < 6) {
        alert("Password must be at least 6 characters.");
        return;
      }

      setLoading(true);

      const cleanEmail = normalizeEmail(email);

      const customerRef = doc(db, "customers", cleanEmail);
      const customerSnap = await getDoc(customerRef);

      if (!customerSnap.exists()) {
        alert(
          "This email is not registered as a Trading Wealth customer. Please contact admin."
        );

        setLoading(false);
        return;
      }

      await createUserWithEmailAndPassword(auth, cleanEmail, password);

      alert("✅ Password created successfully. Please login now.");

      setLoading(false);
      navigate("/customer-login");
    } catch (error) {
      console.error(error);

      if (error.code === "auth/email-already-in-use") {
        alert(
          "Password is already created for this email. Please login or use Forgot Password."
        );
      } else {
        alert(error.message || "Unable to create password.");
      }

      setLoading(false);
    }
  };

  const forgotPassword = async () => {
    try {
      if (!email) {
        alert("Please enter your registered email first.");
        return;
      }

      await sendPasswordResetEmail(auth, normalizeEmail(email));

      alert("Password reset link sent to your email.");
    } catch (error) {
      console.error(error);
      alert("Unable to send password reset email.");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #0f172a, #14532d)",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={6} lg={5}>
            <Card
              className="shadow-lg border-0"
              style={{ borderRadius: "22px" }}
            >
              <Card.Body className="p-4">
                <div className="text-center mb-4">
                  <div
                    style={{
                      width: "85px",
                      height: "85px",
                      borderRadius: "50%",
                      border: "3px solid #22c55e",
                      overflow: "hidden",
                      margin: "0 auto 15px",
                    }}
                  >
                    <img
                      src={logo}
                      alt="Trading Wealth"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>

                  <h2 className="fw-bold mb-1">Create Password</h2>

                  <p className="text-muted mb-0">
                    Create password using your registered customer email.
                  </p>
                </div>

                <Form>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">
                      <FaEnvelope className="me-2 text-success" />
                      Registered Email Address
                    </Form.Label>

                    <Form.Control
                      type="email"
                      placeholder="Enter registered email"
                      value={email}
                      onChange={(event) => setEmail(event.target.value)}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">
                      <FaLock className="me-2 text-primary" />
                      Create Password
                    </Form.Label>

                    <Form.Control
                      type="password"
                      placeholder="Minimum 6 characters"
                      value={password}
                      onChange={(event) => setPassword(event.target.value)}
                    />
                  </Form.Group>

                  <Button
                    variant="success"
                    className="w-100 mb-3"
                    onClick={createPassword}
                    disabled={loading}
                  >
                    <FaUserPlus className="me-2" />
                    {loading ? "Creating..." : "Create Password"}
                  </Button>

                  <Button
                    variant="outline-primary"
                    className="w-100 mb-3"
                    onClick={forgotPassword}
                  >
                    <FaCheckCircle className="me-2" />
                    Already Created? Reset Password
                  </Button>

                  <Link to="/customer-login">
                    <Button variant="outline-dark" className="w-100">
                      <FaArrowLeft className="me-2" />
                      Back to Login
                    </Button>
                  </Link>
                </Form>
              </Card.Body>
            </Card>

            <p className="text-center text-white mt-3 small">
              Only registered Trading Wealth customers can create password.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CustomerRegister;